import Vue from 'vue'

export default {



    // Hanteras i vue.config.js vid utveckling    
    baseUrl: process.env.NODE_ENV === 'production' ? '/tpapi' : '',
    instanceSpecific (host) {
        if(!host)
            host = window.location.hostname.toLowerCase();
        switch(host) {            
            case 'sodexogeo.logivia.se':
                return {
                    sodexoTpBaseUrl: 'https://sodexosthlm.logivia.se',
                    mapcommandUrl: 'https://sodexogeo.logivia.se',    
                }
            case 'sodexogeotest.logivia.se':
                return {
                    sodexoTpBaseUrl: 'https://sodexotest.logivia.se',
                    mapcommandUrl: 'https://sodexogeotest.logivia.se',    
                }
            case 'stjarnkoketgeo.logivia.se':
                return {
                    sodexoTpBaseUrl: 'https://stjarnkoket.logivia.se',
                    mapcommandUrl: 'https://stjarnkoketgeo.logivia.se',    
                }
            default:
                return {
                    sodexoTpBaseUrl: 'http://localhost:60463',
                    mapcommandUrl: 'http://localhost:8080',    
                }
        }
    },
    applicationTitle: 'GEO',    
    customerLogoImg: 'Sodexo_Logotype_Blue.png',
    videofolder: process.env.NODE_ENV === 'production' ? '/videos/' : 'https://images-assets.nasa.gov/video/',
    version: 'SODEXO_2026-09-02',
    keepAliveTimeMs: 60000,
    //mapcommandUrl: process.env.NODE_ENV === 'production' ? 'https://sodexogeo.logivia.se' :  'http://localhost:8081',
    //mapcommandUrl: process.env.NODE_ENV === 'production' ? 'https://stjarnkoketgeo.logivia.se' :  'http://localhost:8081',
    // closerClientUrl: process.env.NODE_ENV === 'production' ? '/v2' : 'http://localhost:8081',
    // pdfUrlPrefix: 'https://rexelpdf.logivia.se/docfiles/' //'https://www.logivia.se/publicdoc/'
}

